import { trackStructuredEvent } from 'src/analytics';

const category = 'interview-transcript-signup';

export function trackFormViewed(interviewToken: string, formType: 'eoi-embedded' | 'popup') {
  trackStructuredEvent({
    action: 'form-viewed',
    category: `${category}-${formType}`,
    label: interviewToken,
  });
}

export function trackFormStart(interviewToken: string, formType: 'eoi-embedded' | 'popup') {
  trackStructuredEvent({
    action: 'form-started',
    category: `${category}-${formType}`,
    label: interviewToken,
  });
}

export function trackFormExit(interviewToken: string, formType: 'eoi-embedded' | 'popup') {
  trackStructuredEvent({
    action: 'form-exited',
    category: `${category}-${formType}`,
    label: interviewToken,
  });
}

export function trackFormSubmitted(
  interviewToken: string,
  didOptIn: boolean,
  formType: 'eoi-embedded' | 'popup' | 'polaris',
) {
  trackStructuredEvent({
    action: 'form-submitted',
    category: `${category}-${formType}`,
    label: interviewToken,
    property: `marketing-${didOptIn ? 'accepted' : 'rejected'}`,
  });
}
